<template>
  <div class="content self_c">
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['My coupon']"
    />
    <!-- vant 的 tab 有問題  老子不想用 -->
    <div
      class="body self_b"
      :style="'min-height:' + window_.bodyH + 'px;'"
    >
      <!-- tab區 -->
      <div
        class="s-tab_box"
        :style="'top:' + window_.tab_top + 'px;'"
      >
        <div
          @click="s_tab_click(2)"
          :class="s_tab.active == 2 ? 'van-active self-active' : ''"
        >
          {{ window_c["Available"] }}
        </div>
        <div
          @click="s_tab_click(3)"
          :class="s_tab.active == 3 ? 'van-active self-active' : ''"
        >
          {{ window_c["Used"] }}
        </div>
        <div
          @click="s_tab_click(4)"
          :class="s_tab.active == 4 ? 'van-active self-active' : ''"
        >
          {{ window_c["Expired"] }}
        </div>
      </div>
      <!-- 內容區 -->

      <van-pull-refresh
        v-model="refreshData.isLoading"
        @refresh="onRefresh"
        :pulling-text="refreshData.pullingText"
        :loosing-text="refreshData.loosingText"
        :loading-text="refreshData.loadingText"
        :success-text="refreshData.successText"
        class="s-tab_content"
        :style="'min-height:' + window_.s_h + 'px;'"
      >
        <van-list
          @load="onDownRefresh"
          v-model="refreshUpData.isLoading"
          :finished="refreshUpData.upFinished"
          :finished-text="refreshUpData.finishedText"
          :loading-text="refreshData.loadingText"
        >
          <div
            class="item_box"
            v-for="(item, index) in couponData"
            :key="index"
            @click="goCouponDetail(index)"
          >
            <div
              class="item-img_"
              :style="'height:' + window_.item_h + 'px;'"
            >
              <div
                class="item_img_mark"
                v-if="s_tab.active == 3 || s_tab.active == 4"
              >
                <div class="item_img_mark_mark"></div>
                <van-image
                  show-loading
                  class="iimm_img"
                  :style="
                    'width:' +
                      window_.item_h / 2 +
                      'px;height:' +
                      window_.item_h / 2 +
                      'px;'
                  "
                  :src="
                    s_tab.active == 3
                      ? require('../../assets/isuse.png')
                      : require('../../assets/timeout.png')
                  "
                >
                </van-image>
              </div>
              <van-image
                :style="'width:100%;height:' + window_.item_h + 'px;'"
                radius="10"
                :src="item.imgUrl"
              >
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20"
                  />
                </template>
                <template v-slot:error>
                  <img src="../../assets/icon/default.png" />
                </template>
              </van-image>
            </div>
            <div class="item-content">
              <div class="item-content_l">
                <div class="item_c_l_name">{{ item.couponTypeName }}</div>
                <div class="item_c_l_rename">{{ item.brandName }}</div>
              </div>
              <div class="item_c_l-time">
                {{ window_c["Validity period"] }}:{{
                  getDate(item.beginDate)
                }}-{{ getDate(item.endDate) }}
              </div>
            </div>
            <div
              class="item_left"
              :style="'top:' + window_.item_top + 'px;'"
            ></div>
            <div
              class="item_right"
              :style="'top:' + window_.item_top + 'px;'"
            ></div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";
import util from "@/js/util.js";
import { getMemberCoupon } from "@/js/api";
import lang_ from "@/js/locales";
export default {
  data () {
    return {
      window_c: {
        "My coupon": "我的優惠券",
        Available: "可使用",
        Used: "已使用",
        Expired: "已過期",
        "Validity period": "使用期限"
      },
      s_tab: {
        active: 2
      },
      window_: {
        bodyH: 0,
        s_h: 0,
        item_h: 0,
        item_top: 0,
        tab_top: 0
      },
      refreshData: {
        // 配置下拉刷新数据
        isLoading: false,
        count: 0,
        pullingText: "下拉既可刷新...",
        loosingText: "釋放立即刷新...",
        loadingText: "加載中...",
        successText: "刷新成功"
      },
      refreshUpData: {
        isLoading: false,
        upFinished: false,
        finishedText: "沒有更多數據了..."
      },
      requestParam: {
        memberId: 0,
        brandId: 0,
        type: 2,
        pageIndex: 0,
        pageSize: 10
      },
      couponData: [],
      loadToast: ""
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    // util.getBrand(this, () => {
    //   this.getMemberCoupon_('down');
    // })
    this.init_lang();
    this.initWindow();
  },
  mounted () { },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c["My coupon"] = lang_.t("My coupon");
      window_c["Available"] = lang_.t("Available");
      window_c["Used"] = lang_.t("Used");
      window_c["Expired"] = lang_.t("Expired");
      window_c["Validity period"] = lang_.t("Validity period");
      this.refreshData["pullingText"] = lang_.t("Drop down to refresh");
      this.refreshData["loosingText"] = lang_.t("Release refresh now");
      this.refreshData["successText"] = lang_.t("Refresh success");
      this.refreshData["loadingText"] = lang_.t("Loading");
      this.refreshUpData["finishedText"] = lang_.t("No more data");
    },
    s_tab_click (e) {
      if (e != this.s_tab.active) {
        this.s_tab.active = e;
        this.requestParam.type = e;
        this.refreshUpData.upFinished = false;
        this.getMemberCoupon_("down");
      }
    },
    goCouponDetail (e) {
      //  已過期和已使用
      if (this.requestParam.type == 3 || this.requestParam.type == 4) {
        return;
      }
      // 將數據轉存到 session中 保持數據一致
      sessionStorage.foodStoryCouponData = JSON.stringify(this.couponData);
      let type =
        this.requestParam.type +
        "_" +
        this.requestParam.pageIndex * this.requestParam.pageSize +
        "_" +
        e;
      let brandId = util.getBrandId(this);
      this.$router.push({
        name: "coupon_detail",
        params: {
          arg: util.setQueryParams([brandId, type])
        }
      });
    },
    initWindow () {
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      this.window_.bodyH = h - 46;
      var s_tab_h = this.window_.bodyH - 40; // util.GETPXBYVW_VH('vw', 10);
      this.window_.s_h = s_tab_h;
      var item_w = w - 20; // util.GETPXBYVW_VH('vw', 2.5);
      this.window_.item_h = item_w / 2;
      this.window_.item_top = item_w / 2 - 25;
      var tab_top_h = 46; // util.GETVW_VHBYPX('vw', 46);
      this.window_.tab_top = tab_top_h;
      // var userinfo = util.getUserInfo(this);
      this.requestParam.brandId = util.getBrandId(this);
      let userInfoStr = util.userInfo.get(this)
      if (userInfoStr) {
        var userinfo = JSON.parse(userInfoStr);
        this.requestParam.memberId = userinfo.memberId;
      }
    },
    getMemberCoupon_ (e) {
      var self = this;
      if (e == "down") {
        self.requestParam.pageIndex = 1;
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: self.refreshData["loadingText"]
      });
      getMemberCoupon(self.requestParam).then(res => {
        console.log(res);
        self.$toast.clear();
        self.refreshData.isLoading = false;
        if (res.code == 1 || res.success) {
          if (res.data.data.length == 0) {
            this.refreshUpData.isLoading = false;
            this.refreshUpData.upFinished = true;
          } else {
            this.refreshUpData.isLoading = false;
          }
          if (e == 'down') {
            self.couponData = res.data.data;
          } else {
            self.couponData = self.couponData.concat(res.data.data);
          }
        }


      });
    },
    onRefresh () {
      //下拉刷新回调
      this.refreshUpData.upFinished = false;
      this.getMemberCoupon_("down");
    },
    onDownRefresh () {
      this.requestParam.pageIndex += 1;
      this.getMemberCoupon_("up");
    },
    getDate (e) {
      if (e == undefined || e == null || e == "") {
        return "";
      }
      if (e.split(" ")[0]) {
        return e.split(" ")[0].replace(/-/g, "/");
      }
    },
    errorImg (img) {
      return util.errorImg(img);
    }
  },
  components: {
    headNav
  }
};
</script>
<style scoped>
.body {
  /* padding-top: 86px; */
  /* height:calc(100% - 46px); */
}

.pc_content .body {
  padding-top: 86px;
}

.content {
  background-color: #f5f5f5;
}

.s-tab_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  background-color: #fff;
  position: fixed;
  top: 46px;
  z-index: 4;
}

.s-tab_box:after {
  position: absolute;
  content: "";
  height: 1px;
  left: 0;
  right: 0;
  bottom: 0;
  transform: rotateY(0.5);
  background-color: #ebedf0;
}

.s-tab_box div {
  width: 33.33%;
  /* padding: 2.5vw; */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.van-active {
  position: relative;
  color: #23bfa7;
}

.van-active:after {
  position: absolute;
  content: "";
  height: 4px;
  left: 0;
  right: 0;
  bottom: 0;
  transform: rotateY(0.5);
  background-color: #23bfa7;
}

.s-tab_content {
  /* height: 90vh; */
  padding: 30px 10px 0 10px;
}

.pc_content .s-tab_content {
  padding-top: 0;
}

.item_box {
  /* background-color: #00a9ff; */
  position: relative;
  border-radius: 8px;
  margin-top: 20px;
}

.item-img_ {
  /* background-color: #16b498; */
  border-radius: 10px;
  position: relative;
}

.item-img_ img {
  height: 100%;
  width: 100%;
  border-radius: 8px;
}

.item-content {
  /* height: 50px; */
  background-color: #fff;
  border-radius: 8px;
}

.item_left {
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: rgb(245, 245, 245);
  border-radius: 50%;
  left: -25px;
  z-index: 3;
}

.item_right {
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: rgb(245, 245, 245);
  border-radius: 50%;
  right: -25px;
  z-index: 3;
}

.item-content_l {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item_c_l_name {
  padding: 30px 10px 10px;
  font-weight: 600;
}

.item_c_l_rename {
  padding: 30px 10px 10px;
  margin-left: auto;
  font-weight: 600;
}

.item_c_l-time {
  padding: 0 10px 10px;
  /* font-size: 14px; */
}

/* 2019-12-13 14:55:51 */

.item_img_mark {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  border-radius: 10px;
}

.item_img_mark_mark {
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.6;
  border-radius: 10px;
}

.iimm_img {
  position: absolute;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/vipCard/my_coupon.vue